import Player from '@vimeo/player';
import PreventScroll from '../preventScroll';

class Popup {
    static instances = [];

    constructor() {
        this.popups = document.querySelectorAll('.popup[data-popup]');

        this.initPopups();
        Popup.listenMenu();

        // Constructor to open popup if url exist
        const currentURL = new URL(window.location.href);
        const tValue = currentURL.searchParams.get('t');

        if (tValue !== null) {
            for (let i = 0; i < Popup.instances.length; i += 1) {
                if (Popup.instances[i].idUrl === currentURL.searchParams.get('t')) {
                    Popup.open(
                        Popup.instances[i],
                        document.getElementById(`close-${Popup.instances[i].getAttribute('data-popup')}`),
                    );
                }
            }
        }
    }

    initPopups() {
        this.popups.forEach((popup) => {
            Popup.init(popup);
        });
    }

    static init(popup) {
        const id = popup.getAttribute('data-popup');
        const preventScroll = popup.getAttribute('data-preventscroll') !== null;
        const closer = document.getElementById(`close-${id}`);
        const opener = document.getElementById(`open-${id}`);
        // eslint-disable-next-line
        popup.idUrl = popup.getAttribute("url-id");

        Popup.instances.push(popup);

        const isHomeVideo = id.match('home');
        const isGallery = id.match('gallery');

        closer.addEventListener('keydown', (e) => {
            if (e.key === 'Tab') return;
            e.preventDefault();
            Popup.close(popup, preventScroll);
            if (isGallery) popup.classList.remove('flex');
            if (isHomeVideo) Popup.stopVideo(popup);
        });

        closer.addEventListener('click', () => {
            Popup.close(popup, preventScroll);
            if (isGallery) popup.classList.add('flex');
            if (isHomeVideo) Popup.stopVideo(popup);
        });

        opener.addEventListener('click', () => {
            Popup.open(popup, closer, preventScroll);
            if (isGallery) popup.classList.add('flex');
        });
    }

    static open(popup, closer) {
        popup.classList.remove('hidden');
        closer.focus();
        // if (preventScroll && window.innerHeight >= 710) PreventScroll.disableScroll();

        setTimeout(() => {
            popup.classList.add('popup--active');
        }, 10);

        Popup.appendContent(popup.querySelectorAll('[data-popupappend]'));

        // Add params in url
        const currentURL = new URL(window.location.href);

        currentURL.searchParams.set('t', popup.idUrl);
        // eslint-disable-next-line
        history.pushState(null, null, currentURL);
    }

    static close(popup, preventScroll) {
        const slider = popup.querySelector('.splide');
        if (slider) slider.style.display = 'none';

        const vimeo = popup.querySelector('.testimonial_vimeo');
        if (vimeo) {
            const video = new Player(vimeo);
            video.pause();
        }

        popup.classList.remove('popup--active');
        if (preventScroll) PreventScroll.enableScroll();

        setTimeout(() => {
            popup.classList.add('hidden');
            if (slider) slider.style.display = 'block';
        }, 500);

        // Delete params in url
        const currentURL = new URL(window.location.href);
        const urlWithoutQuery = currentURL.origin + currentURL.pathname;
        // eslint-disable-next-line
        history.pushState(null, null, urlWithoutQuery);
    }

    static appendContent(elements) {
        elements.forEach((elem) => {
            elem.style.transition = "none"; // eslint-disable-line
            elem.style.opacity = "0"; // eslint-disable-line
            const { transform } = elem.style;
            elem.style.transform = "translateY(50px)"; // eslint-disable-line

            const index = elem.getAttribute('data-popupappend');
            setTimeout(() => {
                elem.style.transition = "opacity .2s, transform .35s ease-out"; // eslint-disable-line
                elem.style.opacity = "1"; // eslint-disable-line
                elem.style.transform = "translateY(0)"; // eslint-disable-line
                setTimeout(() => {
                    elem.style.transform = transform; //eslint-disable-line
                }, 400);
            }, 300 + 150 * index);
        });
    }

    static listenMenu() {
        window.addEventListener('openMenu', () => {
            Popup.appendContent(document.querySelectorAll('.header [data-popupappend]'));
        });
    }

    static stopVideo(popup) {
        const player = new Player(popup.querySelector('iframe'));
        player.pause();
    }
}

export default Popup;
